import { OrderState } from '@types';

/* cspell:disable-next-line */
export const deliveryAddressDemo = 'Parque Empresarial de Eiras, Lote 22 3020–430 Coimbra';

export const deliveryOptionsDemo = [
    /* cspell:disable */
    { value: 'option-ctt', text: 'CTT Expresso - 2 dias úteis' },
    { value: 'option-standard', text: 'Standard - 3 dias úteis' },
    { value: 'option-dhl', text: 'DHL - 2 dias úteis' },
    /* cspell:enable */
];

export const orderProductsDemo = {
    total: 10.55,
    list: [
        // cspell:disable
        { id: 'product-demo-1', attributes: [], name: 'Sapato de criança', quantity: 1, price: 17.5 },
        { id: 'product-demo-2', attributes: [], name: 'Sapato de mulher', quantity: 1, price: 17.5 },
        // cspell:enable
    ],
};

export const orderBillsDemo = {
    total: 11.55,
    list: [{ id: 'ABC123', number: 'ABC123', date: '2024-06-20', value: 14.32, file: 'test.test' }],
};

export const orderDeliveriesDemo = {
    total: 12.55,
    list: [{ id: '001', address: deliveryAddressDemo, option: deliveryOptionsDemo[1] }],
};

export const orderLogs = [
    /* cspell:disable */
    { id: '01', date: '29/05/2024', time: '11:00', state: OrderState.pending, notes: 'Pago MBWAY' },
    { id: '02', date: '29/05/2024', time: '11:00', state: OrderState.cancelled, notes: 'Pago MBWAY' },
    {
        id: '03',
        date: '29/05/2024',
        time: '11:00',
        state: OrderState.pending,
        notes: 'Telemóvel: 000 000 000<br />Valor: 33,15€',
    },
    /* cspell:enable */
];

export const ordersDemo = [
    /* cspell:disable */
    {
        reference: '001',
        client: 'António Rodrigues',
        total: 45.5,
        nProducts: 1,
        date: '2024-04-06',
        state: OrderState.cancelled,
    },
    { reference: '002', client: 'Bárbara Jorge', total: 12.5, nProducts: 3, date: '2024-04-16', state: OrderState.delivered },
    { reference: '003', client: 'Natali Vale', total: 31.5, nProducts: 1, date: '2024-04-16', state: OrderState.pending },
    { reference: '004', client: 'João Carvalho', total: 87, nProducts: 4, date: '2024-04-16', state: OrderState.pending },
    {
        reference: '005',
        client: 'Andreia Martins',
        total: 150,
        nProducts: 2,
        date: '2024-04-16',
        state: OrderState.paid,
    },
    { reference: '006', client: 'Marco Pires', total: 45.5, nProducts: 1, date: '2024-04-16', state: OrderState.shipped },
    { reference: '007', client: 'Bárbara Jorge', total: 12.5, nProducts: 3, date: '2024-04-16', state: OrderState.pending },
    {
        reference: '008',
        client: 'António Rodrigues com um nome muito comprido tipo lorem ipsum dolor sit amet',
        total: 31.5,
        nProducts: 1,
        date: '2024-04-16',
        state: OrderState.pending,
    },
    { reference: '009', client: 'João Carvalho', total: 87, nProducts: 4, date: '2024-04-16', state: OrderState.cancelled },
    {
        reference: '010',
        client: 'Andreia Martins',
        total: 150,
        nProducts: 2,
        date: '2024-04-16',
        state: OrderState.pending,
    },
    /* cspell:enable */
];

/* cspell:disable */
export const paymentWithMbWayDemo = { total: 12.55, name: 'MbWay', method: 'mbway', phoneNumber: '910000555' };
export const paymentWithMultibancoDemo = { total: 12.55, name: 'Multibanco', method: 'multibanco', multibancoReference: '333000555' };
export const paymentWithCardDemo = { total: 12.55, name: 'Cartão de Débito/Crédito', method: 'card' };
/* cspell:enable */

export const statisticsDemo = {
    totalTransactionsPrice: 350,
    ordersCount: 10,
    visitsCount: 34,
};

export const orderDetailDemo = {
    reference: '001',
    /* cspell:disable-next-line */
    client: 'Vera Rodrigues',
    date: '2024-04-16T10:34:00',
    total: 33.15,
    state: OrderState.pending,
    /* cspell:disable-next-line */
    deliveryType: 'Morada',
    deliveryExpectedDate: '2024-04-26',
};

export const phoneNumberDemo = '910000000';
